import React from 'react';
import { ControlLink, Stack, Text } from '@moda/om';
import { hrefFor } from '../../routers';
import { AccountOrderDetailPageState } from '../../constants';
import { OrderSummary } from '../../hooks/useOrderSummary';

interface Props {
  orderSummary: OrderSummary;
  orderNumber: string;
}

export const AccountOrderActionPay: React.FC<Props> = ({ orderSummary, orderNumber }) => {
  if (!orderSummary || Number(orderSummary.attributes.paymentSummary.remainingBalance.price) <= 0)
    return null;

  return (
    <Stack alignItems="flex-start" space={1}>
      <ControlLink
        to={hrefFor.OrderDetailPage({
          orderNumber,
          state: AccountOrderDetailPageState.Paying
        })}
      >
        <Text treatment="body2" color="ink">
          Pay Remaining Balance
        </Text>
      </ControlLink>
      {orderSummary?.attributes.isAddressChangeable && (
        <ControlLink
          to={hrefFor.OrderDetailPage({
            orderNumber: orderSummary?.attributes.orderNumber,
            state: AccountOrderDetailPageState.ChangingShippingAddress
          })}
        >
          <Text treatment="body2" color="ink">
            Change Shipping Address
          </Text>
        </ControlLink>
      )}
    </Stack>
  );
};
